export default __webpack_public_path__ + "static/media/paper21.a2fd0515.JPG";